var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('th',[_vm._v("Smeartest")]),_c('th',[_vm._v("Smeardate")]),_c('th',[_vm._v("Smearres")])])
}
var staticRenderFns = []

export { render, staticRenderFns }